import * as React from 'react';
import Svg, { Circle } from 'react-native-svg';

function InProgress(props: any) {
    return (
        <Svg
            width={props.size || 75}
            height={props.size || 75}
            viewBox='0 0 75 75'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            {...props}
        >
            <Circle
                cx={37.5}
                cy={37.5}
                r={6}
                fill={'#109648'}
            />
            <Circle
                cx={61.5}
                cy={37.5}
                r={6}
                fill={'#109648'}
            />
            <Circle
                cx={13.5}
                cy={37.5}
                r={6}
                fill={'#109648'}
            />
        </Svg>
    );
}

export default InProgress;
